// Whether the motion menu is open in this tab (S7): the slide in the editor then shows each build's place in the order.

import { create } from "zustand";

export const useMotionOpen = create<{ open: boolean }>(() => ({ open: false }));
